import api from './client';
import type { ApiResponse } from '../types/common';
import type { GlobalSearchResult } from '../types/search';

export const searchApi = {
  globalSearch: (query: string, options?: { limit?: number }) =>
    api.get<ApiResponse<GlobalSearchResult>>('/search', { params: { q: query, ...options } }),
};
